export const ROLE_REQUEST = 'request';
export const ROLE_REJECT = 'reject';
export const ROLE_VIEWER = 'viewer';
export const ROLE_MODERATOR = 'moderator';
export const ROLE_ORGANIZER = 'organizer';
export const ROLE_SPEAKER = 'speaker';
export const ROLE_TECHNICAL_SUPPORT = 'technical_support';

export const TYPE_KONTUR_FOCUS = 'konturFocus';
export const TYPE_PHOTO = 'photo';

export const REQUIREMENT_FORMAT = 'format';
export const REQUIREMENT_SIZE = 'size';
export const REQUIREMENT_WEIGHT = 'weight';
export const REQUIREMENT_FACE = 'face';
export const REQUIREMENT_ACCESSORIES = 'accessories';

export const ICON_PLUS = 'PlusIcon';
export const ICON_MINUS = 'MinusIcon';

export const STATUS_APPROVED = 'approved';
export const STATUS_REQUEST = 'request';
export const STATUS_REJECT = 'reject';

export const AVAILABLE_TYPES = ['online', 'offline'];
